import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import { Link } from 'react-router';

import SimpleMap from '../Map/SimpleMap';
// constants
import ROLES from '../../constants/Roles';
// components
import AutoComplete from '../Common/AutoComplete';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import DetailView from '../Common/DetailView';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { ListItem } from 'material-ui/List';
// icons
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import PersonAddIcon from 'material-ui/svg-icons/social/person-add';
import VenueIcon from 'material-ui/svg-icons/communication/location-on';
// business logic
import ContactActions from '../../actions/ContactActionCreator';
import ContactStore from '../../stores/ContactStore';

import LocationActions from '../../actions/LocationActionCreator';
import LocationStore from '../../stores/LocationStore';
import LocationContactStore from '../../stores/LocationContactStore';
import VenueActions from '../../actions/VenueActionCreator';
import VenueStore from '../../stores/VenueStore';

import buildContextMenu from '../Common/BuildContextMenu';
import { formatAddress } from '../../utils/StringUtils';

let timeout;

const Location = React.createClass({

    getInitialState: function () {
        const locationId = Number(this.props.routeParams.id);

        return {
            locationId,
            details: {
                id: '',
                name: '',
                description: '',
                type: '',
                address: '',
                address1: '',
                address2: '',
                address3: '',
                city: '',
                state: '',
                postalCode: '',
                country: '',
                countryCode: '',
                latitude: '',
                longitude: '',
                status: '',
                sysStatus: 0,
                venueId: null,
                venueName: ''
            },
            dialog: {
                open: false,
                value: null,
            },
            contacts: [],
            contactList: [],
            venueList: [],
            links: {
                back: '/dashboard/locations',
                edit: '',

            },

        }
    },


    componentDidMount: function() {
        this.locationListener = LocationStore.addListener(this._onChange);
        LocationActions.getById(this.state.locationId);

        LocationContactStore.addChangeListener(this._onLocationContactChange);
        LocationActions.getContacts(this.state.locationId);

        ContactStore.addChangeListener(this._onContactListChange);

        this.venueListener = VenueStore.addListener(this.onVenueChange);
    },

    componentWillUnmount: function() {
        ContactStore.removeChangeListener(this._onContactListChange);
        LocationContactStore.removeChangeListener(this._onLocationContactChange);
        this.locationListener.remove();
        this.venueListener.remove();
    },

    render: function () {
        const { details } = this.state;

        let addressDetails = null;
        if (details.address !== 'N/A') {
            addressDetails = (<li><em>Address: </em>{formatAddress(details)}</li>);
        }

        let contactDetails = null;
        if (this.state.contacts.length > 0) {
            contactDetails = (
                <li><em>Contact{this.state.contacts.length > 1 && 's'}:</em>
                    {this.state.contacts.map(({name}) => name).join(', ')}
                </li>
            );
        }

        let dialog, props;
        switch (this.state.dialog.open) {
            case 'contact':
                props = {
                    title: "Add Contact",
                    open: true,
                    modal: false,
                    onRequestClose: this._closeDialog,
                    actions: [
                        <FlatButton key="cancel" label="Cancel" onTouchTap={this._closeDialog} />,
                        <FlatButton key="submit" label="Submit" onTouchTap={this._dialogSave} disabled={this.state.dialog.value === null} />,
                    ]
                };
                dialog = (
                    <Dialog {...props} >
                        <AutoComplete
                            floatingLabelText="Contact"
                            maxSearchResults={5}
                            dataSource={this.state.contactList}
                            onUpdateInput={this._onContactAutocomplete}
                        />
                    </Dialog>
                );
                break;
            case 'venue':
                props = {
                    title: "Assign to Venue",
                    open: true,
                    modal: false,
                    onRequestClose: this._closeDialog,
                    actions: [
                        <FlatButton key="cancel" label="Cancel" onTouchTap={this._closeDialog} />,
                        <FlatButton key="submit" label="Submit" onTouchTap={this._dialogSave} disabled={this.state.dialog.value === null} />,
                    ]
                };
                dialog = (
                    <Dialog {...props} >
                        <AutoComplete
                            floatingLabelText="Venue"
                            maxSearchResults={5}
                            dataSource={this.state.venueList}
                        />
                    </Dialog>
                );
                break;

            default: break;
        }

        const venueInfo = !details.venueId
            ? ''
            : (<Link to={`/dashboard/venue/${details.venueId}`}>{details.venueName}</Link>);

        let mapElement = null;
        if ((!!details.latitude || details.latitude === 0) && (!!details.longitude) || details.longitude) {
            const latitude = Number(details.latitude);
            const longitude = Number(details.longitude);
            const mapProps = {
                zoom: 15,
                markers: [
                    {
                        title: details.name,
                        lat: latitude,
                        lng: longitude
                    },
                ],
                center: [latitude, longitude]
            };
            mapElement = (
                <CardText>
                    <SimpleMap {...mapProps}/>
                </CardText>
            );
        }

        return (
            <DetailView
                title={details.name}
                backButton={true}
                backTo={this.state.links.back}
                actions={buildContextMenu(this.getMenuItems(), this.context.auth)}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title={details.name}
                            subtitle={details.description}
                        />
                        <CardText className="cent-card-text">
                            <div className='cent-flex-row'>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        <li><em>Capacity: </em>{details.capacity}</li>
                                        <li><em>Status: </em>{details.status}</li>
                                        <li><em>Events: </em><a href={`/dashboard/location/${this.state.locationId}/calendar`}>view calendar</a></li>
                                    </ul>
                                </div>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        {contactDetails}
                                        <li><em>Venue: </em>{venueInfo}</li>
                                        {addressDetails}
                                    </ul>
                                </div>
                            </div>
                        </CardText>
                        {mapElement}
                        {dialog}
                    </Card>
                </div>
            </DetailView>
        );
    },

    _onChange: function(){
        const details = LocationStore.getById(this.state.locationId);
        if (details !== undefined) {
            this.setState(assign({}, this.state, { details: details}));

            if (!details.venueId) {
                VenueActions.getAll();
            }
        }
    },

    _onDelete: function(entityId) {
        if (entityId === this.state.locationId) {
            LocationActions.delete(this.state.details);
            window.location.href = this.state.links.back;
        }
    },

    _onLocationContactChange: function() {
        const contacts = LocationContactStore.getByLocation(this.state.locationId);
        if (contacts !== undefined) {
            const state = assign(this.state, {contacts: contacts});
            this.setState(state);
        }
    },

    _onContactAutocomplete: function(input) {
        clearTimeout(timeout);
        if (input !== undefined && input.length >= 2) {
            timeout = setTimeout(function() { ContactActions.search(input, {limit: 10}); }, 500);
        }
    },

    _onContactListChange: function() {
        const contacts = ContactStore.getAll(); // get by search
        if (contacts !== undefined) {
            const contactList = contacts.map(function(contact) {
                const click = this._onDialogSelect.bind(this, contact);
                return {
                    text: contact.name,
                    value: <ListItem key={contact.id} value={contact.id} primaryText={contact.name} onClick={click} />
                };
            }, this);
            this.setState({contactList});
        }
    },

    _addContact: function(contact) {
        const index = this.state.contacts.findIndex(function(e) { return e !== undefined && e.id == contact.id; });
        if (0 > index) {
            contact.loading = true;
            const contacts = this.state.contacts;
            contacts.push(contact);
            this.setState(assign(this.state, {contacts: contacts}));
            LocationActions.addContact(this.state.locationId, contact.id);
            return true;
        }
        return false;
    },

    getMenuItems: function() {
        return [
            {
                icon: <VenueIcon />,
                label: 'Assign to Venue',
                action: function() { this._openDialog('venue'); }.bind(this),
                condition: {
                    show: !!this.state.details && !this.state.details.venueId,
                    roles: [ROLES.ADMIN]
                }
            },
            {
                icon: <PersonAddIcon />,
                label: 'Add Contact',
                action: function() { this._openDialog('contact'); }.bind(this),
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                link: `/dashboard/location/${this.state.locationId}/edit`,
                icon: <EditIcon />,
                label: 'Edit',
                condition: {
                    roles: [ROLES.ADMIN]
                }
            },
            {
                type: 'deleteDialog',
                dialogType: 'menu',
                value: this.state.locationId,
                title: 'Delete ',
                deleteAction: this._onDelete,
                message: (<span>Are you sure you want to delete this location?</span>),
                condition: {
                    roles: [ROLES.ADMIN]
                }
            }
        ];
    },

    onVenueChange: function() {
        const venues = VenueStore.getAll();
        if (!!venues) {
            const venueList = venues.map((venue) => {
                const click = this._onDialogSelect.bind(this, venue);
                return {
                    text: venue.name,
                    value: <ListItem key={venue.id} value={venue.id} primaryText={venue.name} onClick={click} />
                };
            }, this);
            this.setState({venueList});
        }
    },

    _closeDialog: function() {
        const state = this.state;
        state.dialog.open = false;
        this.setState(this.state);
    },
    _openDialog: function(dialog) {
        const state = this.state;
        state.dialog.open = dialog;
        state.dialog.value = null;
        this.setState(this.state);
    },

    _dialogSave: function() {
        let close = true;
        switch (this.state.dialog.open) {
            case 'contact':
                close = this._addContact(this.state.dialog.value);
                break;
            case 'venue':
                LocationActions.update(this.state.locationId, assign({}, this.state.details, {venueId: this.state.dialog.value.id}));
                break;
            default:
                console.error('Error: unhandled dialog');
                close = false;
        }

        if (close) this._closeDialog();

    },
    _onDialogSelect: function(element) {
        const state = this.state;
        state.dialog.value = element;
        this.setState(state);
    },


});

Location.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Location;
